import type {ExtraInfo} from './types';

const DATA: ExtraInfo = {
  surveyUrl: 'https://forms.gle/7J2ZrMYxsRM7skxy6',
  checkInCode: '7496',
  details: [
    {
      type: 'description',
      heading: 'Event Overview',
      paragraphs: [
        {
          content:
            'How do students without a technical degree break into Japan’s fast-growing tech industry? What challenges do they face—and how do they find their way in?',
        },
        {
          content:
            'In this session, we’re bringing together mentors and recent graduates who studied in Japan and came from non-technical backgrounds, such as liberal arts, business, civil engineering, and more, yet successfully landed their first roles in tech. Through an open and relaxed panel discussion, they’ll share how they explored tech career paths, navigated job hunting, built relevant skills, prepared for interviews, and adapted to their first job in the industry.',
        },
        {
          content:
            'This event marks the first in a new series aimed at empowering students, especially those in regional areas or new to Japan, to shape their career opportunities. It’s hosted in collaboration with students from Hokkaido University who are actively designing their future paths.',
        },
        {
          content:
            'Whether you’re a student, just beginning your job search, or curious about transitioning into tech, this session offers real stories, practical tips, and encouragement to support your journey. Professionals and mentors are also warmly invited to join the conversation and share their insights!',
        },
      ],
    },
    {
      type: 'registration-form',
    },
    {
      type: 'list',
      heading: 'Who is this for',
      items: [
        'Students from non-tech majors aiming for tech careers',
        'International students navigating job hunting in Japan',
        'Japanese students aspired to international tech companies',
        'Students seeking mentorship opportunities',
        'Professionals and mentors eager to connect, share, and support others',
      ],
    },
    {
      type: 'description',
      heading: 'Panelist Introduction',
      paragraphs: [
        {
          heading: 'Yanyan Li, Data Architect, Gran Manibus',
          content:
            'Yanyan is a Data Architect at Gran Manibus, where she helps clients design scalable AI/Data solutions for complex business challenges. She also works part-time at Sophia University, mentoring master students in Applied Data Science on their research and job hunting. She earned a Ph.D. in Civil Engineering from Nagoya University, where her research focused on traffic safety modeling and simulation. After graduation, she began her career as a researcher at the Institute of Materials and Systems for Sustainability (IMaSS) at Nagoya University. She then transitioned into industry, working as a Data Scientist at Rakuten, followed by a role as a Data Architect at Slalom Build Japan.',
        },
        {
          heading: 'Yusuke Harada, Technical Lead, SAP Japan',
          content:
            'Yusuke spent his childhood and attended an international school in Madagascar. Then he came back to Japan to study Liberal Arts at Sophia University. He joined SAP Japan in 2024 and is now responsible for the implementation and maintenance of the procurement software "Ariba," supporting the optimization of business processes. Additionally, Yusuke plans and manages internal events, contributing to team vitality and employee interaction. Leveraging the communication skills and flexibility developed in an international environment, he continues to achieve results across a wide range of tasks.',
        },
        {
          heading: 'Yuka Shiozu, IT Specialist, IBM Japan',
          content: 'Yuka began working at IBM as an IT Specialist in April and is currently undergoing training until July. She graduated from Ritsumeikan University, where she majored in Media Society. Despite having no background in IT or technical skills like programming, she chose to pursue a career in the tech industry. During her job search, she focused primarily on IT companies and most of the short-term internships she participated in were with IT companies.',
        },
      ],
    },
    {
      type: 'schedule',
      heading: 'Timetable',
      items: [
        {
          timeUTC: 1747478700,
          description: 'Online meeting room opens & check-in',
        },
        {
          timeUTC: 1747479600,
          description: 'Opening',
        },
        {
          timeUTC: 1747480500,
          description: 'Panel Discussion',
        },
        {
          timeUTC: 1747482300,
          description: 'Q&A',
        },
        {
          timeUTC: 1747484100,
          description: 'Closing & Feedback',
        },
        {
          timeUTC: 1747485000,
          description: 'Networking (Optional)',
        },
        {
          timeUTC: 1747486800,
          description: 'Event end',
        },
      ],
    },
    {
      type: 'description',
      heading: 'Important Information',
      paragraphs: [
        {
          content:
            'Application: The event is free to attend. Once your registration is confirmed, you will receive a calendar invitation. Please sign up by Thursday, May 15, 2025.',
        },
        {
          content:
            "Language: The event will primarily be conducted in English. However, you're welcome to ask questions in both English and Japanese.",
        },
        {
          content:
            'Video Participation: To foster a warm and engaging atmosphere, we kindly ask all participants to keep their cameras on during the session.',
        },
        {
          content:
            'Photography & Recording: Screenshots and recordings may be taken during the online event for promotional purposes (e.g., social media, future event materials). By registering, you consent to the use of these materials unless you inform us otherwise in advance.',
        },
        {
          content:
            'Schedule: Please note that the event schedule is subject to change on the day of the event.',
        },
        {
          content:
            'Contact: For any event-related inquiries, please contact alliz via email at event@alliz.jp.',
        },
      ],
    },
    {
      type: 'description',
      heading: 'About Host',
      paragraphs: [
        {
          content:
            'alliz is a career mentorship community led by its members, dedicated to career design and development in Japan. We foster mentorship and meaningful connections through community-driven activities, bringing together students, early-career professionals, and mentors from tech-related industries. By sharing experiences, insights, and guidance, we promote mutual growth and learning.',
        },
      ],
    },
  ],
  tags: [],
  thumbnailURL:
    '/static/images/kMASOkQt47/Gw7hhLFlFk6Gi255eZm8AKap8cQS4Y7Z.png',
};

export default DATA;
